import { EstadoSolicitud, EstadoSolicitudItem, SolicitudSeccion } from "../common/enumModel";
import { ILogModel } from "../interfaces/ILogModel";
import { ISolicitudModel } from "../interfaces/ISolicitudModel";
import { ISolicitudDocumentoTecnicoModel } from "../interfaces/solicitud/documento-tecnico/ISolicitudDocumentoTecnicoModel";
// import { ISolicitudDocumentoTecnicoModel } from "../interfaces/solicitud/ISolicitudDocumentoTecnicoModel";
import { ISolicitudEquipoModel } from "../interfaces/solicitud/ISolicitudEquipoModel";
import { ISolicitudPersonaModel } from "../interfaces/solicitud/ISolicitudPersonaModel";
import { ISolicitudVehiculoModel } from "../interfaces/solicitud/ISolicitudVehiculoModel";

import { DocumentacionRequeridaModel } from "./DocumentacionRequeridaModel";
import { EquipoModel } from "./EquipoModel";
import { PersonalModel } from "./PersonalModel";
import { SolicitudDocumentoTecnicoModel } from "./SolicitudDocumentoTecnicoModel";
import { VehiculoModel } from "./VehiculoModel";

export class SolicitudModel implements ISolicitudModel {
    idSolicitud : number;
    codigo: string;
    idContratista?: number;    
    contratista: string; 
    idEstado: EstadoSolicitud;   
    idEstadoDocumentacionTecnica: EstadoSolicitudItem;
    estado : string;
    fechaSolicitud : Date;

    fechaInicio : Date;
    fechaFin : Date;
    idSede : number;
    idSedeSelected?: number;
    nombreSede: string;
    ordenCompra : string; 
    solicitadoPor : string; 

    notificarA : string;    
    trabajo: string;
    motivo : string;    
    
    idTipoVisita: number;
    idTipoVisitaSelected?: number;
    tipoVisita: string;

    documentosRequeridos : Array<DocumentacionRequeridaModel>;

    lista_documentos_personal : Array<DocumentacionRequeridaModel>;
    
    lista_documentos_equipos : Array<DocumentacionRequeridaModel>;
    
    lista_documentos_vehiculos : Array<DocumentacionRequeridaModel>;
    
    lista_documentos_tecnicos : Array<DocumentacionRequeridaModel>;    

    personas: ISolicitudPersonaModel[];
    equipos: ISolicitudEquipoModel[];
    vehiculos: ISolicitudVehiculoModel[];
    documentosTecnicos: ISolicitudDocumentoTecnicoModel[];

    // noAplica_personal: boolean;
    // noAplica_equipos: boolean;
    // noAplica_vehiculos: boolean;    
    // noAplica_documentos: boolean;

    aplicaEquipos: boolean;
    aplicaVehiculos: boolean;
    aplicaDocumentacionTecnica: boolean;
    aplicaPersonas: boolean;


    puedeAprobar: boolean;
    idCoordinador: string;
    comentarioPorAprobacionRechazo: string;

    comentarioPorValidacionDocumentosTecnicos: string;
    comentarioPorCompletar: string;

    logs: ILogModel[] = [];
    logsDocumentacionTecnica: ILogModel[] = [];

    idTipoCreacion: number;
    codigoSolicitante: string;
    totalDocumentos: number;
    totalDocumentosRevisados: number;

    idSolicitudPrevia?: number;
    puedeCambiarSolicitante: Boolean;
    idSupervisor: string;
    idEstadoPrevioAdicion?: EstadoSolicitud;
    idCompania: number;
    idCompaniaSelected?: number;
    compania: string;
    subContratista: string;

    constructor(){
        this.idSolicitud = 0;
        this.codigo = '';
        // this.idContratista = 0;
        this.contratista = '';        
        this.idEstado = EstadoSolicitud.SOLICITADO;
        this.estado = '';
        this.idEstadoDocumentacionTecnica = EstadoSolicitudItem.PENDIENTE;
        this.fechaSolicitud = new Date();
        this.fechaInicio = new Date();
        this.fechaFin = new Date(this.fechaInicio.getFullYear(), this.fechaInicio.getMonth() + 1, this.fechaInicio.getDate());
        this.idSede = 0;
        this.nombreSede = '';
        this.ordenCompra = '';
        this.notificarA = '';
        this.trabajo = '';
        this.motivo = '';
        this.idTipoVisita = 0;
        this.tipoVisita = '';
        this.documentosRequeridos = new Array<DocumentacionRequeridaModel>();
        this.lista_documentos_personal = new Array<DocumentacionRequeridaModel>();
        this.lista_documentos_equipos = new Array<DocumentacionRequeridaModel>();
        this.lista_documentos_vehiculos = new Array<DocumentacionRequeridaModel>();
        this.lista_documentos_tecnicos = new Array<DocumentacionRequeridaModel>();
        
        // this._lista_equipos = new Array<EquipoModel>();
        // this._lista_vehiculos = new Array<VehiculoModel>();
        this.personas = new Array<PersonalModel>();
        this.equipos = new Array<EquipoModel>();
        this.vehiculos = new Array<VehiculoModel>();
        this.documentosTecnicos = new Array<SolicitudDocumentoTecnicoModel>();

        // this.noAplica_personal = false;
        // this.noAplica_equipos = false;
        // this.noAplica_vehiculos = false;
        // this.noAplica_documentos = false;
        this.aplicaEquipos = false;
        this.aplicaVehiculos = false;
        this.aplicaDocumentacionTecnica = false;
        this.aplicaPersonas = false;

        this.puedeAprobar = false;
        this.idCoordinador = '';
        this.comentarioPorAprobacionRechazo = '';
        this.comentarioPorValidacionDocumentosTecnicos = '';
        this.comentarioPorCompletar = '';
        this.idTipoCreacion = 0;
        this.codigoSolicitante ='';
        this.totalDocumentos = 0;
        this.totalDocumentosRevisados = 0;
        this.puedeCambiarSolicitante = false;
        this.solicitadoPor = '';
        this.idSupervisor = '';
        this.idCompania = 0;
        this.compania = '';    
        this.subContratista = '';

    }

    // public lista_documentos_personal() : Array<DocumentacionRequeridaModel> 
    // {
    //     
    // }
}